<template>  
  <div class="notification-list">
    <div class="buttons">
      <a>
        <menu-button
          label="Notifications"
          :close-icon="showNotifications ? 'clear' : 'keyboard_arrow_down'"
          :badge="notificationCount > 0 ? notificationCount.toString() : null"
          @click="toggleNotifications"
        />
      </a>
    </div>
    <md-content v-show="showNotifications" class="notifications md-scrollbar">
      <div 
        v-for="not in nonPopupNotifications" 
        :key="not._id" 
      >
        <notification
          :notification="not"
          @doAction="(action) => doAction(not._id, action)"
        />
      </div>
      <div v-if="notifications.length === 0" class="no-notifications">
        No notifications
      </div>
    </md-content>
    <popup-notifications :notifications="popupNotifications" @dismiss="dismiss" @unread="unread" @doAction="(action, not, callback) => doAction(not._id, action, callback)" />
  </div>
</template>

<script>
import MenuButton from '../../MenuButton';
import Notification from './Notification';
import PopupNotifications from './PopupNotificationsContainer';

export default {
  name: 'notification-list',
  components: {
    MenuButton,
    Notification,
    PopupNotifications,
  },
  props: {
    notifications: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showNotifications: false,
    };
  },
  computed: {
    notificationCount() {
      let result = undefined;
      if (this.notifications && !this.showNotifications) {
        result = this.nonPopupNotifications.length;
      }
      return result;
    },
    nonPopupNotifications() {
      return (this.notifications || []).filter(notif => notif.type !== 'POPUP_MESSAGE');
    },
    popupNotifications() {
      return (this.notifications || []).filter(notif => notif.type === 'POPUP_MESSAGE');
    },
  },
  methods: {
    toggleNotifications() {
      this.showNotifications = !this.showNotifications;
      if (this.showNotifications) {
        this.$analytics.event('Notifications', 'notifications_opened');
      }
    },
    doAction(notificationId, action, callback) {
      this.$emit('action', notificationId, action, callback);
    },
    dismiss(notificationId) {
      this.$emit('dismiss', notificationId);
    },
    unread(notificationId) {
      this.$emit('unread', notificationId);
    },
  },
}
</script>

<style scoped>
.buttons {
  display: flex;
  flex-direction: column;
}
.notifications {
  overflow: auto;
  flex-shrink: 1;
}
.notification-list .md-button {
  width: 100%;
  margin-top: 4px !important;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25) !important;
}
.no-notifications {
  background-color: white;  
  padding: 6px 4px 4px 6px;
}
</style>
